/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ClockWarningIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACHUlEQVR4nMWVO2sUURTHBzRGG1ELC8Vno6J2aiHKNoITZ89jFu6es6uw3YrYWGkVTDptNJ/AbxCDMekC1gohj95oEEFNpVERUVbuOLvezU5m7oYFLxyYvTN7fufxv+cGwf9cxph9RLWbSPocWVeA5DeQ/kqeWabtuyiq7+3bcRiGw0A6DqxfkLWVb/IZSMaMMTu8nF+r1I8Ay0KxY+020kUiOZrrPKrUjyPr6mZOiORimWuXckCrAObYpmVB0vm8KIN0FZRsyRizqwdg61hUhsALkNj9HrUA6fqgAEC63qWuRIoejQz8M2gBS/NfeVieDRqALFMdQJ5ycKsAkrdOg/V7PwBgee+RwVc3gx9eUaGeSwCgp4HkY9pQOzoeRHH1DFH9LLI8tHs2aBew4pe2frKO2hBk+QCkdzMkfw9JXjsAmfJrnHZBymVzuFQqbbcGLE+RdNIYs63ZbA4hVq/0LVN0IMxyqhNgrLcded7qOcVheH23nYr9QIB0wv7XHihkWQPWJ9bsM1Fjz5ZGBXacy09EcyJV4ITdiyJzEFEPpFk8ysgiHLaDyvMQPU56UKmdTGCsrXJcPc9cu7AxgK5FJIeA5F2B87X2nAGWWSerl0j6yvk90wNoKyPvwgHSO8l3LCNFdwVR9WompNRo7ASS0awJG8c39qfRL7v71jmRXN6gtsVMgKuu9NKfBNY3yPrNjva/AH3h0a+5XMAg1h9rT8+PXsiOQQAAAABJRU5ErkJggg==)
 */
export const ClockWarningIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 23c.08 0 .14-.08.11-.16a2.88 2.88 0 0 1 .29-2.31l2.2-3.85c.18-.3-.06-.73-.3-.97l-3-3A1 1 0 0 1 11 12V5a1 1 0 1 1 2 0v6.38c0 .13.05.26.15.35l2.56 2.56c.08.08.22.08.28-.02l.36-.64a3.06 3.06 0 0 1 5.3 0l.3.54c.22.38.78.31.86-.12A11 11 0 1 0 12 23Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M18.09 14.63c.4-.7 1.43-.7 1.82 0l3.96 6.9c.38.66-.12 1.47-.91 1.47h-7.92c-.79 0-1.3-.81-.91-1.48l3.96-6.9Zm.46 1.87h.9c.3 0 .52.26.5.55l-.22 2.02c-.01.16-.17.26-.33.23a1.93 1.93 0 0 0-.8 0c-.16.03-.32-.07-.33-.23l-.21-2.02a.5.5 0 0 1 .5-.55ZM19 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
